import { createAcompanantes } from './mock'
import type { AcompanantesService } from './types'

/**
 * POSPUESTO. La API actual no tiene invitaciones: la implementación real delega en el mock (inventario D29)
 * sin la invitación de ejemplo, y la banda "Datos simulados" lo indica. Contrato: docs/backend/acompanantes.md.
 */
export const acompanantesReal: AcompanantesService = createAcompanantes(false)
